import { Context } from '@wix/wix-chatbot-common/browser';

import { InitialChatbotState } from '../../types';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';

const {
  clientTopology: { startChatUrl },
} = renderModel.get();

export const fetchInitialChatbotState = async (
  params: Record<string, string>,
  context: Context,
): Promise<InitialChatbotState> => {
  try {
    const queryParams = new URLSearchParams(params);
    const apiUrl = `${startChatUrl}?${queryParams.toString()}`;

    const response = await httpClient.getInstance().post<InitialChatbotState>(apiUrl, {
      context,
    });
    return response.data;
  } catch (error) {
    logger.log({
      message: 'failed to fetch InitialChatbotState',
      error,
    });
    console.error(error);
    throw error;
  }
};
